var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
 * This file is part of the nivo project.
 *
 * Copyright 2016-present, Raphaël Benitte.
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */
import React, { Component } from 'react';
import setDisplayName from 'recompose/setDisplayName';
import { PiePropTypes } from './props';
import enhance from './enhance';
import PieLayout from './PieLayout';
import PieCanvasRenderer from './PieCanvasRenderer';

var PieCanvas = function (_Component) {
    _inherits(PieCanvas, _Component);

    function PieCanvas() {
        _classCallCheck(this, PieCanvas);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    PieCanvas.prototype.render = function render() {
        var _props = this.props,
            data = _props.data,
            sortByValue = _props.sortByValue,
            startAngle = _props.startAngle,
            endAngle = _props.endAngle,
            fit = _props.fit,
            padAngle = _props.padAngle,
            innerRadius = _props.innerRadius,
            cornerRadius = _props.cornerRadius,
            width = _props.width,
            height = _props.height,
            colors = _props.colors,
            colorBy = _props.colorBy,
            topProps = _objectWithoutProperties(_props, ['data', 'sortByValue', 'startAngle', 'endAngle', 'fit', 'padAngle', 'innerRadius', 'cornerRadius', 'width', 'height', 'colors', 'colorBy']);

        return React.createElement(
            PieLayout,
            {
                width: width,
                height: height,
                data: data,
                sortByValue: sortByValue,
                startAngle: startAngle,
                endAngle: endAngle,
                fit: fit,
                padAngle: padAngle,
                innerRadius: innerRadius,
                cornerRadius: cornerRadius,
                colors: colors,
                colorBy: colorBy
            },
            function (props) {
                return React.createElement(PieCanvasRenderer, _extends({}, topProps, props));
            }
        );
    };

    return PieCanvas;
}(Component);

PieCanvas.propTypes = process.env.NODE_ENV !== "production" ? PiePropTypes : {};


export default setDisplayName('PieCanvas')(enhance(PieCanvas));